var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_151411",
    "data-name": "Group 151411",
    transform: "translate(-1180.539 -349)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_496",
    "data-name": "Line 496",
    x2: 15,
    transform: "translate(1180.539 349.5)",
    fill: "none",
    stroke: "#125bb2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_498",
    "data-name": "Line 498",
    x2: 15,
    transform: "translate(1180.539 354.5)",
    fill: "none",
    stroke: "#125bb2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_499",
    "data-name": "Line 499",
    x2: 15,
    transform: "translate(1180.539 359.5)",
    fill: "none",
    stroke: "#125bb2",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.ebaff8bf03193cba23dbae6f1d8ac867.svg";
export { ForwardRef as ReactComponent };